import { useQuery } from '@tanstack/react-query';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * #202 Proxmox-VPS-Nodes/Regionen (Operator/Orbit). Ein Node = ein Proxmox-Node
 * mit Default-Storage/Bridge + Cloud-Init-Template (das beim Buchen geklont
 * wird). Nur lesend. M2M-Auth wie alle /v1/admin/*-Endpoints.
 *
 * Feld-Shape = Roh-Zeilen aus `vps_nodes` (snake_case): name, region, pve_node,
 * storage, bridge, template_vmid, iso_storage, is_default, active, notes.
 */
const FIXTURE = {
  nodes: [
    { id: 1, name: 'pve-fsn1', region: 'de-fsn', pve_node: 'pve01', storage: 'local-lvm', bridge: 'vmbr0', template_vmid: 9000, iso_storage: 'local', is_default: true, active: true, notes: 'Falkenstein' },
    { id: 2, name: 'pve-nbg1', region: 'de-nbg', pve_node: 'pve02', storage: 'local-lvm', bridge: 'vmbr0', template_vmid: 9000, iso_storage: 'local', is_default: false, active: true, notes: null },
  ],
};

export function useVpsNodes() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['vps-nodes', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return FIXTURE; }
      return nexusFetch('/v1/admin/vps-nodes');
    },
    refetchInterval: 60_000,
  });
}
